<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1 style="margin-top:250px;">About the Author</h1>
<p>Originally from India, Satyam Sikha Moorty received his PhD in American Literature from the University of Utah, Salt Lake City, and taught for 31 years at Southern Utah University, Cedar City, Utah, courses such as F. Scott Fitzgerald, Shakespeare, Eastern Literatures in English translation (Indian, Chinese, and Japanese); was a Fulbright professor in Yemen, Moldova, (thrice), Austria, and Azerbaijan; was a Balkan scholar at the American University in Bulgaria; published scholarly articles in the U.S., India, France, Spain, Romania, Moldova, Azerbaijan, and Ukraine; published poetry in the U.S., India, Canada, the U.K., South Africa, Moldova, and Azerbaijan; published a book of poems and short stories titled Distant Lands, Diverse Cultures and Moldova: Vigorous Heritage and Variegated Traditions: Poems, Essays, Stories, and Speeches.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?33c2aa0a